module.exports = __webpack_public_path__ + "static/AyalaLandInternational-dcdc6fd60fb630a31ac48e7649fab1a2.png";